import * as React from "react";
import {connect} from "react-redux";
import {bindActionCreators, Dispatch} from "redux";
import {FlashReportSummary} from "../../model/FlashReportSummary.model";
import {formatLongDate} from "../../utils/dateUtil";
import {TrackedLink} from "../base/TrackedLink.component";
import {getFlashReportPDF} from "../flash-report/flashReportActions";
import {getMeetingNotePdf} from "../meeting-note/meetingNoteActions";

interface IRecentUpdateLinkPropsFromParent {
    recentUpdate: FlashReportSummary;
    isLast: boolean;
    managerId: number | undefined;
}

export interface IRecentUpdateLinkPropsFromActions {
    actions: {
        getFlashReportPDF: typeof getFlashReportPDF;
        getMeetingNotePdf: typeof getMeetingNotePdf;
    };
}

export type RecentUpdateLinkProps = IRecentUpdateLinkPropsFromActions & IRecentUpdateLinkPropsFromParent;

const RecentUpdateLinkActions = {
    getFlashReportPDF,
    getMeetingNotePdf,
};

const formatDate = (myDate: Date | null): string => {
    return myDate === null ? "" : formatLongDate(myDate);
};

export const RecentUpdateLinkComponent = (props: RecentUpdateLinkProps) => {
    return (
        <div className="recent-update-row-container">
            <div id={"recent-update-row-" + props.recentUpdate.backstopId} key={props.recentUpdate.backstopId}
                className={`recent-update-row recent-update-row--vertical ${getIsLastClass(props.isLast)}`}>
                <div className="recent-update-row__link">
                    {getTrackedLink(props)}
                </div>
                <div className="recent-update-row__date">
                    <div id={"recent-update-date-" + props.recentUpdate.backstopId}
                         className="recent-update-date date-12">
                        {formatDate(props.recentUpdate.date)}
                    </div>
                </div>
            </div>
            <div className="download-icon fal fa-download" onClick={() => download(props.recentUpdate, props)}/>
        </div>
    );
};

const getTrackedLink = (props: RecentUpdateLinkProps) => {
    const link = `/${props.recentUpdate.urlPrefix}/${props.recentUpdate.backstopId}`;

    return(
        <TrackedLink to={link}
                     className="link-16"
                     gaCategory="Manager Page Flash Report"
                     gaAction="Link"
                     gaLabel={props.recentUpdate.title}>
            <div id={"recent-update-title-" + props.recentUpdate.backstopId}>
                {props.recentUpdate.title}</div>
        </TrackedLink>
    );
};

const getIsLastClass = (isLast: boolean): string => {
    return isLast ? "recent-updates-last-row" : "";
};

const download = (document: FlashReportSummary, props: IRecentUpdateLinkPropsFromActions) => {
        props.actions.getFlashReportPDF (document.backstopId, document.fileName);
};

export const mapDispatchToProps = (dispatch: Dispatch): IRecentUpdateLinkPropsFromActions => {
    return {
        actions: bindActionCreators(RecentUpdateLinkActions, dispatch),
    };
};

const RecentUpdateLink =
    connect<void, IRecentUpdateLinkPropsFromActions, IRecentUpdateLinkPropsFromParent, void>
    (null, mapDispatchToProps)(RecentUpdateLinkComponent);

export default RecentUpdateLink;
